import { Component } from "@angular/core";

@Component({
    selector: 'icon-menu[ui-kit]',
    template: `
    <svg width="16" height="16" viewBox="0 0 16 16"  xmlns="http://www.w3.org/2000/svg">
        <path d="M9.11063 3.11C9.11063 3.72304 8.61366 4.22 8.00063 4.22C7.38759 4.22 6.89062 3.72304 6.89062 3.11C6.89062 2.49696 7.38759 2 8.00063 2C8.61366 2 9.11063 2.49696 9.11063 3.11Z" stroke="none"/>
        <path d="M9.11063 7.99668C9.11063 8.60971 8.61366 9.10668 8.00063 9.10668C7.38759 9.10668 6.89062 8.60971 6.89062 7.99668C6.89062 7.38364 7.38759 6.88668 8.00063 6.88668C8.61366 6.88668 9.11063 7.38364 9.11063 7.99668Z" stroke="none" />
        <path d="M9.11063 12.8833C9.11063 13.4964 8.61366 13.9933 8.00063 13.9933C7.38759 13.9933 6.89062 13.4964 6.89062 12.8833C6.89062 12.2703 7.38759 11.7733 8.00063 11.7733C8.61366 11.7733 9.11063 12.2703 9.11063 12.8833Z" stroke="none" />
    </svg>
    `,
})
export class IconMenu {}
